<template>
    <ru-main-menu :items="ruMenuItems" @itemClick="onTopMenuItemClick">
        <template #logo>
            <ai-logo-full />
        </template>
    </ru-main-menu>
</template>

<script>
export default {
    name: 'ai-top-menu-item-user',
};
</script>

<script setup>
import { onBeforeMount, onMounted, ref } from 'vue';

import AiTopMenuAppSwitcher from '@/layouts/main-layout/components/top-menu/ai-top-menu-item-app-switcher.vue';
import { saveUserDataChanges } from '@/service/userdata-service';

import { getApp, getUserApps } from '@/store/global';
import { getMenuMainLayoutList } from '@/service/meta-service';
import RuMainMenu from '@/components/RuMainMenu/RuMainMenu.vue';

defineProps({
    disable: {
        type: Boolean,
        default: false,
    },
    showButtons: {
        type: Boolean,
        default: true,
    },
});

// const filteredMenu = ref([]);

const appSvgArr = ref({});
const userApps = ref();
const ruMenuItems = ref([]);
onBeforeMount(() => {});
onMounted(async () => {
    const app = getApp();
    app.component('ai-top-menu-app-switcher', AiTopMenuAppSwitcher);
    const data = await getMenuMainLayoutList();
    const appSvgArrTmp = {};
    const { result, items } = await getUserApps();
    if (!result) throw new Error('83ceafcb-90f4-4342-a4b8-51e91b086508');
    userApps.value = items;
    for (const app of items) {
        appSvgArrTmp[app.kod_app] = app.settings.app_svg;
    }
    appSvgArr.value = appSvgArrTmp;
    ruMenuItems.value = data;
    ruMenuItems.value.push({ id: -1111, component: 'ToolBarPanelData' });
});

const emit = defineEmits(['menu-item-click', 'submenu-item-click']);
const menuItemClick = (item, name) => {
    if (item.type === 'item') {
        emit('menu-item-click', item.name);
    } else {
        emit('menu-item-click', name);
    }
};

const onTopMenuItemClick = async item => {
    if (item.route_name === 'nsi-view') {
        const args = {
            viewId: 'nsi-view',
            instanceId: null,
            changes: {
                isButtonVisible: false,
            },
        };
        await saveUserDataChanges(args);
    }
    menuItemClick(false, item.route_name);
};
</script>

<style lang="scss" scoped>
.asuse-panel {
    .logo {
        padding: 4px;
        width: 195px;
        cursor: pointer;
    }

    :deep(.dx-toolbar-items-container) {
        height: 87px;
        min-height: 87px;
        box-shadow:
            0 1px 3px rgba(0, 0, 0, 0.12),
            0 1px 2px rgba(0, 0, 0, 0.24);
    }

    :deep(.dx-toolbar-before) {
        .dx-item {
            height: 87px;
        }

        .dx-icon {
            display: block;
            width: 38px;
            margin: 4px auto 0 auto !important;
            height: 38px;
        }

        .dx-item:hover {
            height: 100%;
            background-color: #445565;

            p,
            .dx-menu-item-text {
                color: white;
            }

            .icon-color img {
                filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(283deg) brightness(103%) contrast(101%);
            }
        }

        .logo-item:hover {
            height: 87px;
            background-color: #ffffff !important;
        }

        .dx-menu .dx-menu-item .dx-menu-item-content {
            padding: 10px 16px !important;
            display: inherit;
        }

        .dx-menu .dx-menu-item .dx-menu-item-content .dx-menu-item-popout-container {
            width: 100% !important;
            display: block !important;
            text-align: center;
            margin-top: -6px;
        }

        .dx-menu .dx-menu-horizontal .dx-menu-item-popout {
            margin: -5px auto 0 auto;
            color: #85a6c5;
        }

        .dx-menu-item-content {
            height: 87px;
            min-width: 120px;
        }

        .dx-item-content {
            text-align: center;
        }

        .dx-toolbar-item:not(:first-child) {
            border-right: 1px solid #85a6c555;
            padding: 0;
        }

        .dx-toolbar-button .dx-menu .dx-menu-item {
            min-height: 28px;
            height: auto;
        }
    }
}
</style>
